import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { ref, computed, reactive, onMounted } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import CosRangePicker from '@/components/CosRangePicker/index'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { LbuFollowUpRecordParams, LbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import { lbuFollowRecordsList, followRecordsDelete } from '@/api/yuntuSales/followUpManage'
import { clueAndcustomerPhaseEnum, customerAllStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { useRouter } from 'vue-router'
import xss from 'xss'
import { listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'

const __default__ = {
  name: 'DcCosLbuFollowUpRecord'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const router = useRouter()
const searchFrom = ref<LbuFollowUpRecordParams>({
  timeType: 0
})
const totalCount = ref(0)

const paramCodeData = reactive<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const columns = computed(() => [
  { title: '主账号代码', dataIndex: 'customerNumber', fixed: 'left' },
  { title: '客户代码', dataIndex: 'tmsCode', fixed: 'left' },
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/lbu/followUpRecord/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'followRefId', width: 200 },
  { title: '客户阶段', dataIndex: 'stage', dicData: clueAndcustomerPhaseEnum },
  { title: '跟进状态', dataIndex: 'followStatus', dicData: customerAllStatusEnum },
  { title: '跟进方式', dataIndex: 'mode', dicData: paramCodeData.lbu_follow_mode },
  { title: '跟进时间', dataIndex: 'startTime', width: 350, sorter: true },
  { title: '联系人姓名', dataIndex: 'contactName' },
  { title: '目的', dataIndex: 'lbuPurpose', width: 200 },
  { title: '跟进过程', dataIndex: 'process', width: 200 },
  { title: '结果/后续', dataIndex: 'result', width: 200 },
  { title: '当前遇到的问题', dataIndex: 'problem', width: 200 },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', fixed: 'right', width: 150 }
])
const fetch = (params: LbuFollowUpRecordParams, callBack: (res: any) => void) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数

  const followRefId = queryForm.followRefId
  if (followRefId !== undefined && followRefId.length > 0) {
    queryForm.followRefIdList = followRefId.split(' ')
    queryForm.followRefId = undefined
  }

  lbuFollowRecordsList(queryForm).then((res) => {
    totalCount.value = res?.data?.totalCount || 0
    callBack(res)
  })
}

const handleAdd = () => {
  router.push({
    path: '/lbu/followUpRecord/add'
  })
}
const handleEdit = (record: LbuFollowUpRecordItem) => {
  router.push({
    path: '/lbu/followUpRecord/edit',
    query: {
      id: record.id
    }
  })
}
const handleCommit = (record: LbuFollowUpRecordItem) => {
  router.push({
    path: '/lbu/followUpRecord/commit',
    query: {
      id: record.id
    }
  })
}
const deleteRow = (record: LbuFollowUpRecordItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelete(record.id).then(() => {
        message.success('删除成功')
        success()
      })
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
onMounted(() => {
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: searchFrom.value,
            "onUpdate:search": _cache[13] || (_cache[13] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "lbufollowUpRecord"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tmsCode",
                    label: "客户代码",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: searchFrom.value.tmsCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.tmsCode) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "mode",
                    label: "跟进方式"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: searchFrom.value.modeList,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.modeList) = $event)),
                        options: paramCodeData.lbu_follow_mode,
                        placeholder: "请选择",
                        mode: "multiple",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "dutyBy",
                    label: "客户负责人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: searchFrom.value.dutyByList,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.dutyByList) = $event)),
                        mode: "multiple"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "updateByList",
                    label: "更新人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: searchFrom.value.updateByList,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.updateByList) = $event)),
                        mode: "multiple"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "mobile",
                    label: "手机号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.mobile,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.mobile) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: searchFrom.value.customerAreaList,
                        "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.customerAreaList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "员工区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: searchFrom.value.employeeRegionList,
                        "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.employeeRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "时间筛选" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchFrom.value.timeType,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.timeType) = $event)),
                            style: {"width":"33%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("创建时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("跟进时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("更新时间")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_unref(CosRangePicker), {
                            startTime: searchFrom.value.startTime,
                            "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom.value.startTime) = $event)),
                            endTime: searchFrom.value.endTime,
                            "onUpdate:endTime": _cache[10] || (_cache[10] = ($event: any) => ((searchFrom.value.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "followRefId",
                    label: "客户ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.followRefId,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((searchFrom.value.followRefId) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "contactName",
                    label: "联系人姓名"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.contactName,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((searchFrom.value.contactName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 写跟进 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_follow_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "306",
                search: _unref(customerListFormat)(searchFrom.value),
                totalCount: totalCount.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search", "totalCount"])), [
                [_directive_permission, 'lbu_follow_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'startTime')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text) + "~" + _toDisplayString(record.endTime), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'process')
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    innerHTML: _unref(xss)(text)
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_MoreButton, { key: 2 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 编辑 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_follow_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_follow_del_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleCommit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 评论 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_follow_comment_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})